
export enum CustomerExpiryReasonCd {
	INACTIVE = 'Inactive',
	MERGE = 'Merge',
	OTHER = 'Other'}
